import Iterations from './Iterations/Iterations';
import Calendar from './Calendar/Calendar';
import { PERIODS_TYPES } from '../../periods/constants';
import { getSelectedPeriodType } from '../../periods/utils';

const PeriodSelection = ({
  selectedPeriod,
  onChange,
  isCustomDateOutsideRange
}) => {
  const selectedPeriodType = getSelectedPeriodType(selectedPeriod);

  switch (selectedPeriodType) {
    case PERIODS_TYPES.ITERATIONS:
      return <Iterations onChange={onChange} />;
    case PERIODS_TYPES.CALENDAR:
      return (
        <Calendar
          selectedPeriod={selectedPeriod}
          onChange={onChange}
          isCustomDateOutsideRange={isCustomDateOutsideRange}
        />
      );
    default:
      return <></>;
  }
};

export default PeriodSelection;
